// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__jDFsw","social":"socials__social__Dwmix","icon":"socials__icon__xLNQ7","navOpen":"socials__navOpen__vgDWH"};